export default "__VITE_ASSET__D45Pwue8__"